import React, { useState, useEffect, useRef } from "react";
import item from "./Asset/88.png"
import un1 from "./Asset/un1.png"
// import item from "./Asset/code.webp"
import vid from "./Asset/read.mp4"
import vid10 from "./Asset/vid10.mp4"
import vid1 from "./Asset/vid.mp4"
import mvid from "./Asset/vmo.mp4"
import pro from "./Asset/pro.jpg"
import v from "./Asset/aud.mp3"
import { Link, useNavigate } from "react-router-dom";
import { FaUserFriends, FaStore, FaChartBar, FaQrcode, FaVolumeUp, FaVolumeMute, } from 'react-icons/fa';
import { IoColorPalette, IoExtensionPuzzleOutline } from "react-icons/io5";
import Contact from "./Contact/Contact";
import Part from "./Paterners/Part";
import AppStoreBanner from "./AppStoreBanner/AppStoreBanner";
import { SlArrowDown } from "react-icons/sl";
import Shop from "./Shop";
import firebase from "../firebaseConfig";
import ScrollToTop from "./ScrollToTop";
import Leaderboard from "./Leaderboard";
import Cookies from "../Cookies";
import Form from "./Form";
import BusinessLeadershipPage from "./T3iSport1";
import ImageGallery from "./Gallery";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";



const Hero = ({ }) => {
    const [inputValue, setInputValue] = useState("");
    const [Read, setRead] = useState(false);
    const navigate = useNavigate();

    const [theme, setTheme] = useState(
      localStorage.getItem("theme") ? localStorage.getItem("theme") : "dark"
      // localStorage.getItem("theme") ? localStorage.getItem("theme") : "light"
    );
// console.log(theme)

    const currentURL = `${window.location.origin}/`;


  const handleClaimLinktree = () => {
    // Pass the input value to the Register component
    navigate(user ? '/profile' : "/register", { state: { username: inputValue } });
    window.scrollTo(0, 0)
  };

  
  const [user, setUser] = useState(null);

  const [CSuser, setCSUser] = useState();
  useEffect(() => {
    
    // Check if user data exists in local storage
    const userData = localStorage.getItem("userData");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup the event listener on unmount
  }, []);


  const FeatureCard = ({ Icon, title, description }) => (
    <div className="bg-white dark:bg-gray-600 text-start shadow-lg rounded-lg p-6 lg:w-96 mx-auto ">
      <div className="flex items-center justify-center w-12 h-12 rounded-full mx-auto mb-4">
        <Icon className="text-purple-600 text-8xl" />
      </div>
      <h3 className="text-3xl font-semibold mb-2">{title}</h3>
      <p className="text-gray-600 dark:text-gray-300">{description}</p>
    </div>
  );

  const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    const togglePlay = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0; // Reset audio to the start when stopped
            } else {
                audioRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    const videoRefLg = useRef(null);
    const videoRefMobile = useRef(null);
    const [isMutedLg, setIsMutedLg] = useState(true); // LG video mute state
    const [isMutedMobile, setIsMutedMobile] = useState(true); // Mobile video mute state
    
    const toggleMuteLg = () => {
      if (videoRefLg.current) {
        videoRefLg.current.muted = !isMutedLg;
        setIsMutedLg(!isMutedLg);
        if (!isMutedLg && videoRefMobile.current) {
          videoRefMobile.current.muted = true;
          setIsMutedMobile(true); // Ensure mobile video is muted when LG video is unmuted
        }
      }
    };
    
    const toggleMuteMobile = () => {
      if (videoRefMobile.current) {
        videoRefMobile.current.muted = !isMutedMobile;
        setIsMutedMobile(!isMutedMobile);
        if (!isMutedMobile && videoRefLg.current) {
          videoRefLg.current.muted = true;
          setIsMutedLg(true); // Ensure LG video is muted when mobile video is unmuted
        }
      }
    };

    const [showDownload, setShowDownload] = useState(false);
  const imgRef = useRef(null);

  const handleDownload = async () => {
    if (!imgRef.current) return;

    // Capture image with moderate quality (reduces file size)
    const canvas = await html2canvas(imgRef.current, { scale: 2 }); // Lower scale for smaller size
    const imgData = canvas.toDataURL("image/jpeg", 0.7); // Convert to JPEG with 70% quality

    // Get dimensions while maintaining aspect ratio
    const imgWidth = 210; // A4 width in mm
    const imgHeight = (canvas.height / canvas.width) * imgWidth; // Preserve aspect ratio

    // Create PDF
    const pdf = new jsPDF({
      orientation: imgWidth > imgHeight ? "landscape" : "portrait",
      unit: "mm",
      format: [imgWidth, imgHeight],
      compression: "FAST", // Enables compression for smaller files
    });

    // Add image with compression
    pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
    pdf.save("download.pdf");
  };

  return (
    <div className="dark:bg-gradient-to-r from-black to-stone-700 bg-white min-h-screen flex w-[100%] flex-col items-center text-center">

  <div className="w-[100%] h-[100%] hidden lg:inline justify-center items-center object-cover">
      <img
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
    
        src="https://t3isports.com/wp-content/uploads/2022/10/T3i-Slides-for-landing-page-3-1536x864.jpeg"
        
      />
      </div>
   
   {/* Mobile */}
 <div className="lg:hidden w-[100%] h-[130%] flex justify-center items-center object-cover absolute">
      <video
        ref={videoRefMobile}
        style={{
          position: "absolute",
          width: "100%",
          top: 0,
          left: 0,
          right: 0,
          height: "100%",
          objectFit: "cover",
        }}
        autoPlay
        loop
        muted={isMutedMobile}
        playsInline
      >
        <source src={mvid} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      </div>



      {/* Main Content */}
      <div className="lg:hidden pt-[220%] flex" />

      <div style={{ display: "flex", alignItems: "center" }} className="text-white">
      {/* Hidden Audio Element */}
      <audio ref={audioRef} src={v} loop />

      {/* Mute/Unmute Button */}
      {/* <button
        onClick={toggleMuteLg}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontSize: "24px",
        }}
        className="absolute hidden lg:inline z-50 lg:top-32 top-28 lg:right-40 right-5"
      >
        {isMutedLg ? <FaVolumeMute /> : <FaVolumeUp />}
      </button> */}

      <button
        onClick={togglePlay}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontSize: "24px",
        }}
        className="absolute lg:hidden flex z-50 lg:top-32 top-28 lg:right-40 right-5"
      >
        {isMutedMobile ? <FaVolumeMute /> : <FaVolumeUp />}
      </button>
    </div>
    
      <div className=" flex flex-col lg:flex-row gap-10 text-start self-center absolute lg:-bottom-5 bottom-32">
      <div className=" align-middle">
          <div 
          className="text-white p-8 rounded-2xl text-center shawdow-2xl max-w-lg"
          // className="text-white lg:bg-[rgba(52,52,52,0.3)] mt-16 dark:bg-[rgba(52,52,52,0.3)] p-8 rounded-2xl text-center shawdow-2xl max-w-lg"
          >
        <img src="https://t3isports.com/wp-content/uploads/2022/10/THE-COMBINE-HEADER-1536x222.png" alt="T3iSports" />
          {/* <p className="mt-0 font-bold text-6xl lg:text-8xl">T3iSports </p>*/}
            <p className="mt-0 text-4xl font-bold lg:text-5xl text-center">Wear-to-Earn<span className="text-[#aaa]">™</span></p>
            {/* <p className="text-yellow-400 ml-2 mr-5 mt-6 max-w-md md:text-base">
              Tech-Forward Sloutions for the Modern Brand
              Join a Tech-Forward Future Just One Chip and One link you share everything you create, 
              curate and sell from your Instagram, TikTok, Twitter, YouTube and other social media profiles.
            </p> */}
          </div>

          <div 
  className="text-white flex self-center items-center justify-center text-[60px] animate-bounce"
>
  <SlArrowDown />
</div>

      
         
      <div className="mt-2 mb-10 flex flex-col items-center">

        {/* <input
        value={`${currentURL}${inputValue}`}
        onChange={(e) => setInputValue(e.target.value.replace(currentURL, ""))}
          type="text"
          placeholder="linktr.ee/yourname"
          className="px-4 font-semibold mb-2 py-3 outline-blue-400 shadow-md h-14 rounded-2xl bg-[rgba(255,255,255,0.6)] dark:bg-[rgba(52,52,52,0.3)] text-gray-600 dark:text-gray-50  placeholder-gray-600  w-[90%] "
          /> */}
        {/* <button onClick={handleClaimLinktree} className="hidden dark:inline px-12 font-semibold shadow-md py-2 outline-none bg-gradient-to-r from-black to-red-500 text-white rounded-full h-12 lg:h-14">
          Get Scouted
          </button> */}
        <button type="button" onClick={handleClaimLinktree} class="transtion group flex h-14 w-60 items-center justify-center rounded-full bg-gradient-to-r from-purple-500 via-red-500 to-pink-500 p-[5px] text-white duration-300 hover:bg-gradient-to-l hover:shadow-2xl hover:shadow-purple-600/30">
    <div class="flex h-full w-full items-center justify-center rounded-full bg-gray-900 transition duration-300 ease-in-out group-hover:bg-gradient-to-br group-hover:from-gray-700 group-hover:to-gray-900 group-hover:transition group-hover:duration-300 group-hover:ease-in-out">
      Get Scouted</div>
  </button>
      </div>

      </div>

      {/* <div className=" self-center items-center text-center lg:-mt-0 -mt-16 "> */}
            {/* <img src={"https://cdn.newtechstore.eu/wp-content/uploads/2024/07/JAKCOM-N3-Smart-Nail-Chip.jpg"} className="rounded-full shadow-lg inline self-center" alt="" /> */}
            {/* <img src={gbk} className="lg:w-[60%] drop-shadow-2xl inline self-center" alt="" /> */}
            {/* <img src={nail} className=" drop-shadow-2xl inline self-center" alt="" /> */}
      {/* </div> */}
     </div>

      {/* Input Field */}


      
<span id="about"></span>
            <div className="dark:bg-gradient-to-r from-black to-stone-700 w-[100%] pb-0 lg:py-0">
              {/* <div className="bg-[#780016] w-[100%] pb-10 lg:py-20"> */}
              
              {/* <div className="bg-white text-center justify-center shadow-lg self-center flex justify-self-center -mt-[30%] lg:-mt-[10%] lg:w-[60%] h-60 w-[80%] lg:h-64">
                        
                          <h1 className="text-center p-2 font-bold text-gray-600">PARTNERS</h1>
  
                </div> */}
                
                <div className="flex flex-col lg:mt-0 lg:flex-row justify-center items-center text-center mx-4 align-middle">
  
                  <div className="dark:text-[#fff] text-[#000] font-bold text-start lg:ml-10 align-middle p-2">
                      <p className="mt-5 text-xl font-bold lg:text-5xl">
                      Style that Pays: Wear, Tap & Earn 
                      </p>
                      
                      <p className="dark:text-[#fff] text-[#000] mt-3 max-w-md font-normal ">
                      T3i Sports is transforming athletics with a data-driven ecosystem that goes beyond performance tracking. 
                      </p>
                      <p className="dark:text-[#fff] text-[#000] mt-3 max-w-md font-normal ">
                      Now integrated with Wear-to-Earn technology, players can convert their progress into tangible rewards, making training more engaging while enhancing scouting visibility.
                                            </p>
                      {/* <p className="dark:text-[#fff] text-[#000] mt-3 max-w-md font-normal ">
                      Step into the future where every piece you wear—clothing, accessories, or even shoes—tells a story and rewards you for living it. With NFC-enabled IoT fashion, your style unlocks exclusive content, interactive experiences, and tangible rewards. It’s not just fashion; it’s a lifestyle that bridges the physical and digital worlds seamlessly
                                                                </p> */}
                      {/* <button
                       className="bg-black dark:bg-gradient-to-r from-black to-red-500 shadow-xl px-10 p-4 mx-3 mt-5 rounded-full text-white hover:scale-110 duration-500 font-bold">Wear to Earn</button> */}
                   </div>
  
                  <div className="hidden lg:inline self-center items-center lg:mt-0 mt-20 text-center">
                      <img src={item} className="rounded-md self-center animate-slowBounce" alt="" />
                  </div>
  
                </div>
  
              </div>

           


              {/* <img src={un1} className="rounded-2xl w-[80%] py-10 self-center" alt="" /> */}

              
      <div
  // style={{width: '100%'}}
  className="w-[100%] h-[100%] justify-center my-5 items-center flex object-cover"
  dangerouslySetInnerHTML={{
    __html: `<video  style="
        position: relative;
    width: 100%;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 100%;
    object-fit: cover;
    // z-index: -1;" 
    autoplay loop muted playsinline>
    <source src=${vid10} type="video/mp4" />
    Your browser does not support the video tag.
    </video>`
  }}
  // <source src=${"https://web-video-resource.gentlemonster.com/assets/stories/jentle-salon/teasing/main/video-src-pc.mp4"} type="video/mp4" />
/>


              <div className="flex flex-col justify-center items-center text-center mx-3 mt-5 align-middle">

<div className=" lg:self-center self-start flex lg:justify-center px-4  lg:mt-0 lg:items-center text-center">
    {/* <img src={cloth} className="rounded-md self-center" alt="" /> */}

    {/* <img src={gbk} className="rounded-2xl lg:w-[40%]" alt="Light Mode Logo" /> */}
    {/* <img src={gbh} className="rounded-2xl lg:w-[40%]" alt="Light Mode Logo" /> */}
    <img src={pro} className="rounded-2xl lg:w-[100%]" alt="Light Mode Logo" />
    {/* <img src={"https://i.ytimg.com/vi/zAraRSu6vGA/hq720.jpg?sqp=-oaymwE7CK4FEIIDSFryq4qpAy0IARUAAAAAGAElAADIQj0AgKJD8AEB-AH-CYAC0AWKAgwIABABGFwgXChcMA8=&rs=AOn4CLBByoKicqhe4MpPNaNw6DgAeazQmA"} className="rounded-2xl lg:w-[100%]" alt="Light Mode Logo" /> */}
    {/* <img src={gb} className="rounded-2xl lg:w-[50%] " alt="Light Mode Logo" /> */}
    {/* <img src={gb} className="rounded-2xl " alt="Light Mode Logo" /> */}
</div>


<div className="dark:text-white lg:px-40 font-bold text-start align-middle px-4 mt-5">
    <p className=" text-2xl font-bold lg:text-4xl">T3i Sports CEO ZO</p>
    <p className="mt-3 font-normal mb-3"> T3i Sports offers a new ecosystem to our grassroots market of middle school and high school athletes through (AMT) Athletic Measurement Testing. With our state of the art timing gates, and our high-impact drill stations we will provide data and analytic tracking, allowing these young athletes the opportunity to benchmark their athleticism while managing their long-term development for scouting advantages, as we continue filling the void in the market.
<a href="https://www.T3iSports.com" target="_blank" className="text-blue-500 pl-1">learn more </a>
</p>
    <ImageGallery />
    {/* <iframe src="https://drive.google.com/file/d/1QNgRSYX2lK-T8CnERp17aTnzl-ykz_7o/preview" className="w-full mb-10 lg:h-[480px] rounded-lg shadow-lg" ></iframe> */}
    {/* <iframe src="https://drive.google.com/file/d/1QNgRSYX2lK-T8CnERp17aTnzl-ykz_7o/preview" className="w-full mb-10 lg:h-[480px]" allow="autoplay; encrypted-media" ></iframe> */}
 </div>

</div>

        

<div
  className="relative w-fit my-5 mx-auto"
  onMouseEnter={() => setShowDownload(true)}
  onMouseLeave={() => setShowDownload(false)}
>
  <img
    ref={imgRef}
    src={un1}
    className="rounded-2xl lg:w-[100%] max-h-[800px] object-contain"
    alt="Light Mode Logo"
  />

  {/* Overlay + Button */}
  <div
    className={`absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center transition-opacity duration-300 ${
      showDownload ? "opacity-100" : "opacity-0"
    }`}
  >
    <button
      className="bg-[#555] text-white px-6 py-3 rounded-lg shadow-lg text-lg font-semibold transition-transform duration-300 transform hover:scale-105"
      onClick={handleDownload}
    >
      Download PDF
    </button>
  </div>
</div>         



<div className="dark:text-white  w-[100%] mt-5 lg:pb-10">
<div className="dark:text-white justify-center items-center lg:flex ">
<div
  // style={{width: '100%'}}
  className="w-[100%] lg:w-[50%] h-[100%] justify-center items-center flex object-cover"
  dangerouslySetInnerHTML={{
    __html: `<video  style="
        position: relative;
    width: 100%;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
    padding: 5px;
    // z-index: -1;" 
    autoplay loop muted playsinline>
    <source src=${vid} type="video/mp4" />
    Your browser does not support the video tag.
    </video>`
  }}
  // <source src=${"https://web-video-resource.gentlemonster.com/assets/stories/jentle-salon/teasing/main/video-src-pc.mp4"} type="video/mp4" />
/>

  <div>

<h2 className="text-2xl font-bold pt-2">Get Scouted</h2>
<p className="px-5  text-sm">Simply by tapping the T3i Sports logo on your garment</p>
<p className=" text-sm mb-5 lg:pb-10 text-gray-500">Make Friends. Earn Points. Claim Rewards.</p>

  </div>


  </div>

  </div>



  <BusinessLeadershipPage />
              <Shop title={'me'} />

              <Leaderboard />

         


{/* <img src={"https://t3isports.com/wp-content/uploads/2022/09/Affiliates-and-Partners-1.png"} className="rounded-2xl px-5 self-center" alt="" /> */}
<div className=" w-[100%]">
          <Contact />
            {/* <Part/> */}
</div>
     {/* <Part /> */}

     {/* <Form title={'me'}/> */}


         

     
              
                
    </div>
  );
};

export default Hero;
